import React from "react";

export function ReviewCreativeModal({ creative, onClose }) {
  if (!creative) return null;
  const inventoryLabel = Array.isArray(creative.audio_types) && creative.audio_types.length > 0
    ? creative.audio_types.map(t => t.display_name).join(", ")
    : "All Types";

  const rows = [
    { label: "Name", value: creative.name || "—" },
    { label: "Tags", value: Array.isArray(creative.labels) && creative.labels.length ? creative.labels.join(", ") : "—" },
    { label: "Status", value: creative.tag || "—" },
    { label: "Duration", value: `${creative.duration} seconds` },
    { label: "Start date", value: creative.start_date || "—" },
    { label: "End date", value: creative.end_date || "—" },
    { label: "Inventory Types", value: inventoryLabel },
  ];
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.3)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:200, padding:16 }}>
      <div style={{ background:"#FFFFFF", border:"1px solid #E2E2E2", borderRadius:20, width:"100%", maxWidth:560, maxHeight:"90vh", overflowY:"auto", position:"relative", boxShadow:"0 20px 60px rgba(0,0,0,0.15)" }}>
        <div style={{ padding:"28px 28px 20px", borderBottom:"1px solid #F0F0F0" }}>
          <button onClick={onClose} style={{ position:"absolute", top:16, right:20, background:"none", border:"none", color:"#626262", fontSize:20, cursor:"pointer" }}>✕</button>
          <div style={{ fontSize:11, color:"#7b7b7b", letterSpacing:1, textTransform:"uppercase", marginBottom:6 }}>Creative</div>
          <h2 style={{ fontSize:20, fontWeight:600, color:"#151515", margin:0, fontFamily:"'Clash Display Variable','Clash Display',sans-serif" }}>Review</h2>
        </div>
        <div style={{ padding:"24px 28px" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
            {rows.map((d) => (
              <div key={d.label}>
                <div style={{ fontSize:10, color:"#7b7b7b", textTransform:"uppercase", letterSpacing:1, marginBottom:3 }}>{d.label}</div>
                <div style={{ fontSize:13, color:"#151515", fontWeight:500 }}>{d.value}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize:11, color:"#7b7b7b", textTransform:"uppercase", letterSpacing:1, marginBottom:8 }}>Script</div>
          <div style={{ background:"#FAFAFA", border:"1px solid #E2E2E2", borderRadius:12, padding:16, color:"#151515", fontSize:13, lineHeight:1.6, whiteSpace:"pre-wrap" }}>{creative.script || "—"}</div>
          <button onClick={onClose} style={{ marginTop:20, padding:"10px 20px", background:"#F0F0F0", color:"#626262", border:"none", borderRadius:8, fontSize:13, cursor:"pointer" }}>Close</button>
        </div>
      </div>
    </div>
  );
}
